import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core'
import { PlatformService } from '@services/platform.service'
import moment from 'moment/moment'

@Component({
	selector: 'sb-footer',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './footer.component.html',
	standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {
	@Input() dark = false

	year = moment().format('YYYY')
	// No app o rodapé some; a versão fica no login e abaixo de Sair (spec 058).
	hideFooter = false

	constructor(private platform: PlatformService) {}

	ngOnInit(): void {
		this.hideFooter = this.platform.mobile
		this.platform.onMobile(mobile => (this.hideFooter = mobile))
	}

	ngOnDestroy(): void {}
}
